import config from "./global"

Object.assign(config, {
  apiUrl: "https://live-api.parlement-ouvert.fr/",
  appTitle: "Live.parlement-ouvert.fr",
  appUrl: "https://live.parlement-ouvert.fr/",
  twitterName: "#BureauOuvert",
})

export default config



//////////////////
// WEBPACK FOOTER
// ./config/production.js
// module id = 254
// module chunks = 0